module.exports = __webpack_public_path__ + "img/unfound.30ef3859.jpg";